import { c as _c } from "react/compiler-runtime";
const Cross = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg viewBox="0 0 16 16"><path d="M4.70001 4.7L11.3 11.3" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" /><path d="M4.70001 11.3L11.3 4.7" stroke="currentColor" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Cross;